import * as _ from 'underscore';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'material-ui/Button';
import CheckIcon from '@material-ui/icons/Check';

import * as Utils from '../../../lib/designerUtils';
import Console from '../../../lib/debug';
import { redzoneTypes, workoutParamTypes } from '../../../lib/paramTypes';

export class AddedExerciseClass extends Component {
    state = { displayNotes: false };

    getSummaryLeaderBoardTag = () => {
        if (!this.props.summary) {
            return null;
        }

        let isRedzone =
            this.props.summary.redzone_value &&
            this.props.summary.redzone_value !== '';

        if (!isRedzone) {
            return null;
        }
        return (
            <span className="leaderboard-tag-value">
                ({this.props.summary.redzone_value})
            </span>
        );
    };

    getLeaderboardText = type => {
        if (!type) {
            return '';
        }
        let redzoneType = _.find(redzoneTypes, { id: parseInt(type) });
        return `FOR ${redzoneType.title}`.toUpperCase();
    };

    getLeaderboardTag = () => {
        let isRedzone = this.props.block && this.props.block.redzone_type;
        if (!isRedzone) {
            return null;
        }
        let leaderboardText = this.getLeaderboardText(
            this.props.block.redzone_type
        );
        if (!leaderboardText) {
            return null;
        }
        return (
            <div className="leaderboard-tag">
                <i className="mdi mdi-trophy" />
                {leaderboardText}
                {this.getSummaryLeaderBoardTag()}
            </div>
        );
    };

    toggleNotesVisibility(e) {
        e.preventDefault();
        this.setState(() => ({
            displayNotes: !this.state.displayNotes
        }));
    }
    render() {
        Console.render('Exercise');
        const {
            exercise,
            block,
            position,
            isLast,
            isPreview,
            calendarInstructionsEnabled,
            sessionSummary,
            summary: exerciseSummary
        } = this.props;

        const session = sessionSummary;

        let instruction,
            redzone,
            typeSearch = null;
        let noLine = true;
        let testedFlag = false;

        if (block.exerciseKeys) {
            noLine =
                block.exerciseKeys.length === 1 ||
                block.exerciseKeys.length === 0 ||
                isLast;
            if (noLine === undefined) {
                noLine = true;
            }
        } else {
            noLine = block.addedExercises.length === 1 || isLast;
        }
        let exerciseClasses = `item-section-exercise ${
            noLine ? 'no-line' : ''
        }`;

        let hasSummary = false;
        let completed = null;
        let logged = sessionSummary && sessionSummary.logged == 1;
        let summaryInfo = null;
        let outstandingDetail = null;
        let testedTag = null;
        if (exerciseSummary) {
            testedFlag = this.props.summary.resets_working_max === 1;
            completed = this.props.summary.completed === 1;
            hasSummary = true;
            let progressWM = null;
            if (this.props.summary.is_wm && this.props.summary.is_up === 1) {
                progressWM = (
                    <div className="orange-detail">
                        <span>
                            <i className="mdi mdi-arrow-up" />WM{' '}
                        </span>{' '}
                    </div>
                );
            } else if (
                this.props.summary.is_wm &&
                this.props.summary.is_up === 0
            ) {
                progressWM = (
                    <div className="orange-detail">
                        <span>
                            <i className="mdi mdi-arrow-down" />WM
                        </span>
                    </div>
                );
            }
            let personalRecord = this.props.summary.is_pr ? (
                <div className="icon-detail">
                    <span>
                        <i className="mdi mdi-star" />PR
                    </span>
                </div>
            ) : null;
            outstandingDetail = (
                <div className="extra-detail">
                    {progressWM}
                    {personalRecord}
                </div>
            );
            if (testedFlag) {
                testedTag = (
                    <div className="tag">
                        <i className="mdi mdi-check" />TESTED
                    </div>
                );
            }
        }

        let exerciseCount = 0;
        if (block.exerciseKeys) {
            exerciseCount = block.exerciseKeys.length;
        } else {
            exerciseCount = block.addedExercises.length;
        }

        if (
            calendarInstructionsEnabled &&
            exercise &&
            exercise.instruction &&
            exercise.instruction.length > 0
        ) {
            instruction = !/^\s+$/g.test(exercise.instruction) ? (
                <pre className="description-toggle">{exercise.instruction}</pre>
            ) : null;
        }

        let blockIndex = 0;

        if (session.addedSets && session.addedSets.length > 0) {
            typeSearch = typeof session.addedSets[0];
        }
        if (session.addedSets && typeSearch === 'number') {
            if (
                typeof block.key === 'string' &&
                block.key.indexOf('k::') >= 0
            ) {
                blockIndex = session.addedSets.indexOf(
                    block.saved_workout_set_id
                );
            } else {
                blockIndex = session.addedSets.indexOf(
                    parseInt(block.saved_workout_set_id)
                );
            }
        } else if (session.addedSets && typeSearch !== 'number') {
            blockIndex = session.addedSets.indexOf(block.saved_workout_set_id);
        }

        blockIndex += session.sets.length;

        let subtitle = Utils.getBlockTitle(blockIndex) + position;
        subtitle =
            exerciseCount > 1 ? subtitle : Utils.getBlockTitle(blockIndex);

        let subtitleSummary = Utils.getBlockTitle(blockIndex) + position;
        subtitleSummary =
            exerciseCount > 1 ? subtitle : Utils.getBlockTitle(blockIndex);

        let subtitleClass = 'alphabet-icon';
        let subtitleClassSummary = 'alphabet-icon';

        let prescriptionClass = 'prescription';
        let prescriptionClassSummary = 'prescription';
        let wasCompleted = false;
        // Green or yellow
        if (hasSummary && logged) {
            wasCompleted = exerciseSummary.completed === 1;

            let paramTypes = [exercise.param_1_type, exercise.param_2_type];
            let isLWP = paramTypes.includes(workoutParamTypes.LINEAR);
            if (exercise.abr !== exerciseSummary.abr && !isLWP) {
                summaryInfo = (
                    <div className="prescription summary-prescription">
                        {exerciseSummary.abr}
                    </div>
                );
            }
        }

        if (wasCompleted) {
            subtitleClass += ' fill-color-green';
        }

        let exerciseRender = null;
        let exerciseNotes = null;
        if (exercise && exerciseCount >= 1) {
            let theExercise =
                _.find(this.props.exerciseRef, { id: exercise.exercise_id }) ||
                exercise.title;
            if (
                exercise.abr &&
                exercise.abr.toLowerCase().indexOf('undefined') >= 0
            ) {
                exercise.abr = '';
            }
            if (
                exercise.abr2 &&
                exercise.abr2.toLowerCase().indexOf('undefined') >= 0
            ) {
                exercise.abr2 = '';
            }
            let parseAbr1 = { __html: exercise.abr };
            let parseAbr2 = { __html: exercise.abr2 };
            let abrHTML = <div dangerouslySetInnerHTML={parseAbr1} />;
            let abr2HTML = <div dangerouslySetInnerHTML={parseAbr2} />;
            let title = null;

            const titleFromExerciseSummary = exerciseSummary
                ? exerciseSummary.title
                : null;
            const titleFromExerciseTemplate =
                theExercise && theExercise.hasOwnProperty('title')
                    ? theExercise.title
                    : theExercise;

            const titleToDisplay = titleFromExerciseSummary
                ? titleFromExerciseSummary
                : titleFromExerciseTemplate;

            if (theExercise) {
                title = (
                    <strong className="title">
                        <div>{titleToDisplay}</div>
                    </strong>
                );
            }

            let leaderboardTag = null;
            let leaderboardTagVisible = noLine && isLast;
            if (leaderboardTagVisible) {
                leaderboardTag = this.getLeaderboardTag();
            }

            if (exerciseSummary) {
                if (exerciseSummary.redzone_value) {
                    redzone = (
                        <span className="redzone-value-summary">
                            {' '}
                            ({exerciseSummary.redzone_value}){' '}
                        </span>
                    );
                }
            }

            if (exerciseSummary && exerciseSummary.notes !== null) {
                let notes = this.state.displayNotes ? (
                    <div className="inside-notes">{exerciseSummary.notes}</div>
                ) : null;
                exerciseNotes = (
                    <div className="exercise-notes">
                        <Button onClick={this.toggleNotesVisibility.bind(this)}>
                            <i className="mdi mdi-message-text-outline" />
                        </Button>
                        {notes}
                    </div>
                );
            }

            exerciseRender = (
                <li className={exerciseClasses}>
                    <div className="default-view">
                        <div className="exercise-title">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">
                                {title}
                                <span className={prescriptionClass}>
                                    {' '}
                                    {abrHTML} {abr2HTML}
                                </span>{' '}
                                {summaryInfo} {redzone}
                            </div>
                        </div>
                        {testedTag}
                        {leaderboardTag}
                        {outstandingDetail}
                        {exerciseNotes}
                        {instruction}
                    </div>

                    <div className="summary-view layout-column">
                        <div className="exercise-title">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">
                                {title}
                                <span className={prescriptionClassSummary}>
                                    {' '}
                                    {abrHTML} {abr2HTML}
                                </span>{' '}
                                {summaryInfo} {redzone}
                            </div>
                        </div>
                        {testedTag}
                        {leaderboardTag}
                        {outstandingDetail}
                        {exerciseNotes}
                        {instruction}
                    </div>
                </li>
            );
        } else {
            let title = <strong className="title">{block.title}</strong>;
            if (!isPreview) {
                title = (
                    <strong className="title">
                        <span>{block.title}</span>
                    </strong>
                );
            }

            exerciseRender = (
                <li className={exerciseClasses}>
                    <div className="exercise-title">
                        <div className="default-view">
                            <span className={subtitleClass}>{subtitle}</span>
                            <div className="exercise-title-info">{title}</div>
                        </div>
                        <div className="summary-view">
                            <span className={subtitleClassSummary}>
                                {subtitleSummary}
                            </span>
                            <div className="exercise-title-info">{title}</div>
                        </div>
                    </div>
                    {instruction}
                </li>
            );
        }

        return exerciseRender;
    }
}

const mapStateToProps = (state, ownProps) => {
    const exercise = state.summary.calendarSummaryAddedExercises[ownProps.item];
    let exerciseKey = ownProps.exerciseKey;
    let workoutId = ownProps.session.workout_id;

    return {
        ...ownProps,
        exercise,
        summary: exercise,
        sessionSummary: state.summary.calendarSummarySessionTree[workoutId],
        exerciseRef: state.library.exerciseRef
    };
};

export default connect(mapStateToProps)(AddedExerciseClass);



// WEBPACK FOOTER //
// ./src/v5/addedBlocks/components/AddedExercise.jsx